import { GenericGaProps } from '@/utils/gaTypes';
import { ResponsiveImageSet } from '@/utils/ResponsiveImage';

export interface IItem {
  imgSrcs?: ResponsiveImageSet;
  link?: string;
  name?: string;
  description?: string;
  altText?: string;
}

export type IItemWithGAEvents = GenericGaProps & IItem;

export interface IVideoItem {
  videoSrc: string;
  posterSrc?: string;
  overlaySrc?: string;
  link?: string;
  name?: string;
  description?: string;
}

export interface IHomePageItem {
  altText: string;
  imgSrcs: string;
  name: string;
  description: string;
  HoverImageAltText: string;
  hoverImage: string;
  link: string;
}

export enum carouselInfoType {
  category = 'category',
  product = 'product',
  video = 'video',
}

export interface ICarouselInfo {
  name: string;
  type: 'product' | 'category' | 'video';
}

export interface ICarouselCustomStyles {
  container: string;
  image: string;
  arrowPositions: string;
}
